import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelButtonText: {
    id: 'Checkout.ShippingInfoStep.cancelButtonText',
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
  },
  required: {
    id: 'Checkout.ShippingInfoStep.required',
    description: 'Required label',
    defaultMessage: 'Required',
  },
  invalidEmail: {
    id: 'Checkout.ShippingInfoStep.invalidEmail',
    description: 'Invalid email label',
    defaultMessage: 'Invalid email address',
  },
  requiredEmail: {
    id: 'Checkout.ShippingInfoStep.requiredEmail',
    description: 'Required email label',
    defaultMessage: 'Email address is required',
  },
  invalidFirstName: {
    id: 'Checkout.ShippingInfoStep.invalidFirstName',
    description: 'Invalid first name',
    defaultMessage: 'Invalid first name',
  },
  requiredFirstName: {
    id: 'Checkout.ShippingInfoStep.requiredFirstName',
    defaultMessage: 'First name is required',
  },
  requiredStreetName: {
    id: 'Checkout.ShippingInfoStep.requiredStreetName',
    defaultMessage: 'Street address is required',
  },
  requiredZipCode: {
    id: 'Checkout.ShippingInfoStep.requiredZipCode',
    defaultMessage: 'Zip code is required',
  },
  requiredCity: {
    id: 'Checkout.ShippingInfoStep.requiredCity',
    defaultMessage: 'City is required',
  },
  invalidPhone: {
    id: 'Checkout.ShippingInfoStep.invalidPhone',
    defaultMessage: 'Phone number must be 10 digits. (000) 000-0000',
  },
  requiredState: {
    id: 'Checkout.ShippingInfoStep.requiredState',
    defaultMessage: 'Select a state',
  },
  invalidLastName: {
    id: 'Checkout.ShippingInfoStep.invalidLastName',
    defaultMessage: 'Invalid last name',
  },
  requiredLastname: {
    id: 'Checkout.ShippingInfoStep.requiredLastname',
    defaultMessage: 'Last name is required',
  },
  notAcceptedPOBox: {
    id: 'Checkout.ShippingInfoStep.notAcceptedPOBox',
    description: 'P.O. Boxes are not accepted.',
    defaultMessage: 'P.O. Boxes are not accepted',
  },
  updateChangesButtonText: {
    id: 'Checkout.ShippingInfoStep.updateChangesButtonText',
    description: 'Save changes button text',
    defaultMessage: 'Save Changes',
  },
  nextStepButtonText: {
    id: 'Checkout.ShippingInfoStep.nextStepButtonText',
    description: 'Next step button text',
    defaultMessage: 'Continue to Delivery',
  },
  signupForNewsletter: {
    id: 'Checkout.ShippingInfoStep.signupForNewsletter',
    defaultMessage:
      'Sign up to get insider access to Purple tech, deals, product releases, and more!',
  },
  signupForNewsletterShopPay: {
    id: 'Checkout.ShippingInfoStep.signupForNewsletterShopPay',
    defaultMessage:
      'Sign up for news and exclusive offers from Purple.',
  },
});
